<script setup lang="ts">
import { WidthVariants } from '~/types/Content'
import { cardTransformer, CardFields } from './cardHelpers'

type ThreeUpCardPanelProps = {
  cards: CardFields[]
  title?: string
  width?: WidthVariants
}

const props = defineProps<ThreeUpCardPanelProps>()
const preset = props.width === 'wide' ? 'three-up-wide' : 'three-up'
</script>

<template>
  <section class="threeup-panel" data-testid="threeup-panel">
    <div :class="width === 'wide' ? 'container-full' : 'container-custom'">
      <div class="threeup-panel__header">
        <h3 class="threeup-panel__title heading-2" v-if="title">{{ title }}</h3>
      </div>
      <div class="threeup-panel__cards">
        <Card v-for="card in cards.slice(0, 3)" v-bind="cardTransformer(card)" variant="three-up" :preset="preset" />
      </div>
    </div>
  </section>
</template>

<style lang="postcss">
.threeup-panel {
  margin-bottom: var(--component-space);

  .container-custom {
    margin: 0 auto;
    max-width: var(--container-max-width); /* 1280px */
    @media (--tablet) {
      padding-inline: var(--space-20);
    }
    @media (--desktop) {
      padding-inline: 1rem;
    }
  }
  .container-full {
    @media (--mobile-only) {
      padding-inline: 0;
    }
  }

  .threeup-panel__header {
    text-align: center;
  }

  .threeup-panel__title {
    margin-bottom: var(--space-70);
  }

  .threeup-panel__cards {
    width: 100%;
    margin-top: var(--space-90);
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    column-gap: var(--space-20);
    row-gap: var(--space-100);
    overflow: hidden;

    @media (--tablet) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }
}
</style>
.
